class ModalReceiveInvoiceCtrl {
    constructor($scope, $uibModalInstance, items1,logger) {
        const start = Number(items1.invoiceNumberStart)
        const count = Number(items1.invoiceCount)
        $scope.sureCount = count;
        items1.invoiceNumber = `${startNumFilter(start)} - ${startNumFilter(start + count - 1)}` // 计算发票号码（发票起始号码 + 发票数量 - 1）
        $scope.modalContent = { // 模态框内容
            title: '发票读入',
            alertMessage: '开票点-' + items1.operateDevice.diskName+'-设备号[' + items1.operateDevice.diskNo + ']',
            imageUrl: './assets/images/cartoon.png',
            param: items1,
        }
        // 点击取消
        $scope.cancel = () => {
            $uibModalInstance.dismiss('cancel')
        }
        // 点击确定
        $scope.ok = () => {
            if($scope.sureCount<1){
                logger.logError('领票数量['+$scope.sureCount+']必须大于0')
                return;
            }
            if($scope.sureCount>count){
                logger.logError('领票数量['+$scope.sureCount+']大于最大可领数[' + count +']')
                return
            }
            $scope.modalContent.param.sureCount = $scope.sureCount
            $uibModalInstance.close($scope.modalContent.param)
        }

        function startNumFilter(input) {
            if (input === null || input === undefined) return input
            if ((`${input}`).length < 8) {
                for (let i = 0; i < 8 - (`${input}`).length;) {
                    input = `0${input}`
                }
            }
            return input
        }
    }
}

ModalReceiveInvoiceCtrl.$inject = [
    '$scope',
    '$uibModalInstance',
    'items1',
    'logger'
]

export default ModalReceiveInvoiceCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/receiveBranchInvoice/modalReceiveInvoiceCtrl.js